import { openBlock, createElementBlock, mergeProps, renderSlot, createElementVNode, createCommentVNode } from 'vue';

const _hoisted_1 = ["width", "height", "fill", "transform"];
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = ["stroke"];
const _hoisted_4 = ["stroke"];
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = /*#__PURE__*/createElementVNode("circle", {
  cx: "128",
  cy: "128",
  r: "88",
  opacity: "0.2"
}, null, -1);
const _hoisted_7 = ["stroke"];
const _hoisted_8 = ["stroke"];
const _hoisted_9 = {
  key: 2
};
const _hoisted_10 = /*#__PURE__*/createElementVNode("path", {
  d: "M223.3,116a117.3,117.3,0,0,1,.7,12A96,96,0,0,1,70,204.5c24.6-6.2,53.5-18.5,82-34.9S205.6,134.2,223.3,116Zm22.5-56c-5.5-9.5-20.3-18.4-59.8-8.5A96,96,0,0,0,32,128a117.3,117.3,0,0,0,.7,12C4.4,169.2,4.8,186.5,10.2,196c3.7,6.4,11.9,12.8,29.8,12.8a121.7,121.7,0,0,0,25.5-3.2l4.5-1.1a105,105,0,0,1-14.2-13.3c-18.7,3.3-29.3,1-31.7-3.2-1.5-2.6-.7-7.5,2.3-13.4A85.7,85.7,0,0,1,37.1,159a95.2,95.2,0,0,0,18.7,32.2l6.2-1.3c24-5.3,53.1-17.5,82-34.2s54-35.8,70.6-53.9a62,62,0,0,0,4.3-4.8,95.2,95.2,0,0,0-18.7-32.2,83.9,83.9,0,0,1,19-1.5c6.6.4,11.2,2.1,12.7,4.7,2.4,4.2-.9,14.5-13,29a107.3,107.3,0,0,1,4.4,19l3.1-3.3C251.7,85.2,250.9,68.9,245.8,60Z"
}, null, -1);
const _hoisted_11 = [_hoisted_10];
const _hoisted_12 = {
  key: 3
};
const _hoisted_13 = ["stroke"];
const _hoisted_14 = ["stroke"];
const _hoisted_15 = {
  key: 4
};
const _hoisted_16 = ["stroke"];
const _hoisted_17 = ["stroke"];
const _hoisted_18 = {
  key: 5
};
const _hoisted_19 = ["stroke"];
const _hoisted_20 = ["stroke"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    width: _ctx.size,
    height: _ctx.size,
    fill: _ctx.color,
    transform: _ctx.mirrored ? 'scale(-1, 1)' : undefined
  }, _ctx.$attrs), [renderSlot(_ctx.$slots, "default"), _ctx.weight === 'bold' ? (openBlock(), createElementBlock("g", _hoisted_2, [createElementVNode("circle", {
    cx: "128",
    cy: "128",
    r: "84",
    fill: "none",
    stroke: _ctx.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "24"
  }, null, 8, _hoisted_3), createElementVNode("path", {
    d: "M179.5,61.6c30.1-8.9,52.9-8.8,59.4,2.4,11,19.1-29.7,63.3-90.9,98.6S28.2,211.1,17.1,192c-6.4-11.2,4.9-31,27.7-52.6",
    fill: "none",
    stroke: _ctx.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "24"
  }, null, 8, _hoisted_4)])) : _ctx.weight === 'duotone' ? (openBlock(), createElementBlock("g", _hoisted_5, [_hoisted_6, createElementVNode("circle", {
    cx: "128",
    cy: "128",
    r: "88",
    fill: "none",
    stroke: _ctx.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "16"
  }, null, 8, _hoisted_7), createElementVNode("path", {
    d: "M184.2,60.3c27.7-7.6,48.5-6.9,54.7,3.7,11,19.1-29.7,63.3-90.9,98.6S28.2,211.1,17.1,192c-6.1-10.6,3.7-29,24.1-49.2",
    fill: "none",
    stroke: _ctx.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "16"
  }, null, 8, _hoisted_8)])) : _ctx.weight === 'fill' ? (openBlock(), createElementBlock("g", _hoisted_9, _hoisted_11)) : _ctx.weight === 'light' ? (openBlock(), createElementBlock("g", _hoisted_12, [createElementVNode("circle", {
    cx: "128",
    cy: "128",
    r: "88",
    fill: "none",
    stroke: _ctx.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "12"
  }, null, 8, _hoisted_13), createElementVNode("path", {
    d: "M184.2,60.3c27.7-7.6,48.5-6.9,54.7,3.7,11,19.1-29.7,63.3-90.9,98.6S28.2,211.1,17.1,192c-6.1-10.6,3.7-29,24.1-49.2",
    fill: "none",
    stroke: _ctx.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "12"
  }, null, 8, _hoisted_14)])) : _ctx.weight === 'thin' ? (openBlock(), createElementBlock("g", _hoisted_15, [createElementVNode("circle", {
    cx: "128",
    cy: "128",
    r: "88",
    fill: "none",
    stroke: _ctx.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "8"
  }, null, 8, _hoisted_16), createElementVNode("path", {
    d: "M184.2,60.3c27.7-7.6,48.5-6.9,54.7,3.7,11,19.1-29.7,63.3-90.9,98.6S28.2,211.1,17.1,192c-6.1-10.6,3.7-29,24.1-49.2",
    fill: "none",
    stroke: _ctx.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "8"
  }, null, 8, _hoisted_17)])) : _ctx.weight === 'regular' ? (openBlock(), createElementBlock("g", _hoisted_18, [createElementVNode("circle", {
    cx: "128",
    cy: "128",
    r: "88",
    fill: "none",
    stroke: _ctx.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "16"
  }, null, 8, _hoisted_19), createElementVNode("path", {
    d: "M184.2,60.3c27.7-7.6,48.5-6.9,54.7,3.7,11,19.1-29.7,63.3-90.9,98.6S28.2,211.1,17.1,192c-6.1-10.6,3.7-29,24.1-49.2",
    fill: "none",
    stroke: _ctx.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "16"
  }, null, 8, _hoisted_20)])) : createCommentVNode("", true)], 16, _hoisted_1);
}

export { render };
